<template>
  <div class="swiper_rotate">
    <div>
      <div class="rotate_box">
        <div class="rotate_pic"></div>
      </div>
      <div class="swiper_box">
        <div v-for="(item, index) in dataList" :key="index"
             class="swiper_div" @click="imgClick(item)">
          <el-row style="width: 100%;height: 70%">
            <img :src="item.Img" width="100%" height="100%">
          </el-row>
          <el-row
            style="width: 100%;height: 30%;background-color: #e8e8e8;display: flex;align-items: center;text-align: center;overflow: auto">
            <div class="text"
              style="line-height: 2vh;font-size: 1.65vh;font-weight: bold;color: #04687e;width: 100%;font-family: fzxbsjt">
              {{ item.title }}
            </div>
            <!-- <div class="xw-text">
              {{ item.zhaiYao }}
            </div> -->

          </el-row>
          <!--                <span class="slide-box-small">-->
          <!--                    “{{item.title}}”-->
          <!--                </span>-->
        </div>
      </div>
    </div>
    <div id="next" @click="next()">
      <i class="el-icon-caret-right next" @click="nextImage"></i>

    </div>
    <div id="prev" @click="prev()">
      <i class="el-icon-caret-left prev" @click="prevImage"></i>
    </div>
  </div>

</template>

<script>
import {getnewList} from "../../api/resouces";

export default {
  name: "carousel_swiper1",
  data() {
    return {
      currentIndex: 0,
      dataList: [require(`@/assets/img/strategicbg001.png`), require(`@/assets/img/aboutbg001.png`), require(`@/assets/img/strategicbg001.png`), require(`@/assets/img/aboutbg001.png`), require(`@/assets/img/strategicbg001.png`)],
      autoplayInterval: null,
      titleTree: [],
      pid: '',
      classId: 43,
      chgID: 0,
    };
  },
  created() {
    this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))


  },
  mounted() {
    setTimeout(() => {
      this.init()

    }, 1000);

  },
  methods: {
    setData(data) {
      this.dataList = data
    },
    init() {
      let next = document.getElementById("next")
      let prev = document.getElementById('prev')
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box > div');
      this.chgID = 0
    },
    next() {
      const swiperDiv = document.querySelectorAll('.swiper_box > div')
      this.chgID++
      this.btnCommon()
    },
    prev() {
      const swiperDiv = document.querySelectorAll('.swiper_box > div')
      this.chgID--
      // this.chgID = this.chgID < 0 ? 0 : this.chgID
      this.btnCommon()
    },
    btnCommon() {
      const next = document.querySelector('#next')  //后一个按钮
      const prev = document.querySelector('#prev')    //前一个按钮
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box > div')

      rotatePic.style.transform = this.chgID > swiperDiv.length - 3 ? `rotate(0deg)` : this.chgID < 0 ? `rotate(-${(swiperDiv.length - 3) * 45}deg)` : `rotate(-${this.chgID * 45}deg)`
      swiperBox.style.transform = this.chgID > swiperDiv.length - 3 ? `translateX(0%)` : this.chgID < 0 ? `translateX(-${(swiperDiv.length - 3) * 102 / swiperDiv.length}%)` : `translateX(-${this.chgID * 102 / swiperDiv.length}%)`
      this.chgID = this.chgID > swiperDiv.length - 3 ? 0 : this.chgID < 0 ? this.chgID = swiperDiv.length - 3 : this.chgID
      for (let i = 0; i < swiperDiv.length; i++) {
        if (i == this.chgID) {
          swiperDiv[i].style.transform = `scale(1)`
          swiperDiv[i].style.transitionDuration = `1s`
        } else {
          swiperDiv[i].style.transform = `scale(1)`
          swiperDiv[i].style.transitionDuration = `1s`

        }
      }
    },
    imgClick(obj) {
      this.titleTree.children.forEach((item, index) => {
        if (item.children != null && item.children.length > 0) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id == obj.classId) {
              this.pid = item2.data.columnPid
            } else {
              if (item2.children != null) {
                item2.children.forEach((ite, ind) => {
                  if (ite.data.id == obj.classId) {
                    this.pid = ite.data.columnPid
                  }
                })
              }
            }
          })
        }

      });
      // this.titleTree.children.forEach((item, index) => {
      //   if (item.children != null) {
      //     item.children.forEach((item2, index2) => {
      //       if (item2.data.id === obj.classId) {
      //         this.pid = item2.data.columnPid
      //       }
      //     })
      //   }
      // });
      this.$router.push({
        path: '/detail',
        query: {
          pid: this.pid,
          id: obj.classId,
          detailId: obj.id,
        }
      })
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.dataList.length) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        // if((this.chgID+2) == this.dataList.length){
        this.next();
        // }
      }, 3000); // 自动播放间隔，单位毫秒
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },

  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  //图片点击跳转事件

};
</script>

<style scoped lang="less">
@media only screen and (min-width: 800px) {
  * {
    margin: 0;
    padding: 0;
  }

  .swiper_rotate {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .rotate_box {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    overflow: hidden;
    position: relative;
  }

  .rotate_circle {
    width: 800px;
    height: 800px;
    position: relative;
    margin: 200px auto;
    border-radius: 50%;
    background: radial-gradient(closest-side, rgb(94, 103, 253) 65%, rgb(18, 187, 253) 100%);
  }

  .rotate_pic {
    width: 50em;
    height: 50em;
    position: relative;
    position: absolute;
    top: -200px;
    left: -200px;
    transition: ease-in-out .5s;
  }

  .rotate_pic img {
    width: 20%;
    height: 100%;
    position: absolute;
    left: 40%;
  }

  .rotate_pic img:nth-child(2) {
    transform: rotate(45deg);
  }

  .rotate_pic img:nth-child(3) {
    transform: rotate(90deg);
  }

  .rotate_pic img:nth-child(4) {
    transform: rotate(135deg);
  }

  .rotate_pic img:nth-child(5) {
    transform: rotate(180deg);
  }

  .shadow_box {
    width: 100%;
    height: 65%;
    position: absolute;
    top: 400px;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    filter: blur(15px);

  }

  .swiper_box {
    height: 85%;
    //width: 90%;
    position: absolute;
    top: 11%;
    left: 1.5%;
    /* transform: translate(-50%,-50%); */
    display: flex;
    flex-direction: row;
    transition: ease-in-out .5s;
    justify-content: center;
    background-size: cover;
  }

  .swiper_div {
    width: calc(18vw);
    height: 100%;
    /* background: rgb(255, 255, 255, .6); */
    margin: 0 calc(2.4vw);
    border-radius: 5px;
    box-shadow: 1px 4px 4px 2px rgba(0, 0, 0, 0.23);

    //display: flex;
    //justify-content: center;
    //align-items: center;
    //background-size: 100% 100%;
    //position: relative;
    cursor: pointer;
  }

  #next,
  #prev {
    position: absolute;
    /* left: 50%;  */
    top: 40%;
    width: 70px;
    cursor: pointer;
    font-size: 6vh;
    /* transform: translate(-50%, -50%); */
  }

  #next {
    right: -25px;
  }

  #prev {
    left: -25px;
    /* opacity: .6; */
    /* pointer-events: none; */

  }

  .slide-box-small {
    position: absolute;
    bottom: 14%;
    left: 6%;
    color: #fffefe;
    border-left: #fffefe 0.2em solid;
    padding-left: 0.5em;
    width: 60%;
    text-align: left;
    font-size: 1em;
    font-weight: bold;
  }

  .xw-text {
    font-size: 2vh;
    text-align: left;
    text-indent: 2em;
    padding: 5px 10px 0vh 10px;
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 以省略号显示被隐藏文本 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 4; /* 限制显示的行数 */
  }
}

@media only screen and (max-width: 800px) {
  * {
    margin: 0;
    padding: 0;
  }

  .swiper_rotate {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .rotate_box {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    overflow: hidden;
    position: relative;
  }

  .rotate_circle {
    width: 800px;
    height: 800px;
    position: relative;
    margin: 200px auto;
    border-radius: 50%;
    background: radial-gradient(closest-side, rgb(94, 103, 253) 65%, rgb(18, 187, 253) 100%);
  }

  .rotate_pic {
    width: 50em;
    height: 50em;
    position: relative;
    position: absolute;
    top: -200px;
    left: -200px;
    transition: ease-in-out .5s;
  }

  .rotate_pic img {
    width: 30%;
    height: 100%;
    position: absolute;
    left: 40%;
  }

  .rotate_pic img:nth-child(2) {
    transform: rotate(45deg);
  }

  .rotate_pic img:nth-child(3) {
    transform: rotate(90deg);
  }

  .rotate_pic img:nth-child(4) {
    transform: rotate(135deg);
  }

  .rotate_pic img:nth-child(5) {
    transform: rotate(180deg);
  }

  .shadow_box {
    width: 100%;
    height: 65%;
    position: absolute;
    top: 400px;
    /* background: linear-gradient(to right, rgb(178, 71, 253) 30%, rgb(243, 99, 248) 100%); */
    filter: blur(15px);

  }

  .swiper_box {
    height: 85%;
    //width: 90%;
    position: absolute;
    top: 11%;
    left: 1.5%;
    /* transform: translate(-50%,-50%); */
    display: flex;
    flex-direction: row;
    transition: ease-in-out .5s;
    justify-content: center;
    background-size: cover;
  }

  .swiper_div {
    width: 150px;
    height: 100%;
    /* background: rgb(255, 255, 255, .6); */
    margin: 0 calc(2.4vw);
    border-radius: 5px;
    box-shadow: 1px 4px 4px 2px rgba(0, 0, 0, 0.23);

    //display: flex;
    //justify-content: center;
    //align-items: center;
    //background-size: 100% 100%;
    //position: relative;
    cursor: pointer;
  }

  #next,
  #prev {
    position: absolute;
    /* left: 50%;  */
    top: 40%;
    width: 70px;
    cursor: pointer;
    font-size: 6vh;
    /* transform: translate(-50%, -50%); */
  }

  #next {
    right: -25px;
  }

  #prev {
    left: -25px;
    /* opacity: .6; */
    /* pointer-events: none; */

  }

  .slide-box-small {
    position: absolute;
    bottom: 14%;
    left: 6%;
    color: #fffefe;
    border-left: #fffefe 0.2em solid;
    padding-left: 0.5em;
    width: 60%;
    text-align: left;
    font-size: 1em;
    font-weight: bold;
  }

  .xw-text {
    font-size: 2vh;
    text-align: left;
    text-indent: 2em;
    padding: 5px 10px 0vh 10px;
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 以省略号显示被隐藏文本 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 4; /* 限制显示的行数 */
  }

  .text{
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carousel_swiper1.vue